var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isUnlocked)?_c('button',{staticClass:"c-ra-pet-remembrance-button",style:(_vm.petStyle),on:{"click":_vm.toggleRemembrance}},[(_vm.hasRemembrance)?_c('span',[_vm._v(" Remembrance given to "+_vm._s(_vm.name)+" ")]):_c('span',[_vm._v(" Give Remembrance to "+_vm._s(_vm.name)+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }